import(/* webpackMode: "eager" */ "/var/www/html/frontend/components/default/services/app/storage.service.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/frontend/components/default/views/root/RootViewPage.tsx");
